module.exports = __webpack_public_path__ + "img/adlightech_logo_2.28f78406.png";